export { useSpecialties, useSpecialtiesResult } from './Specialties';
